import { createFileRoute } from "@tanstack/react-router"
import { LogoutPage } from "@/pages"

export const Route = createFileRoute("/_authenticated/_account/logout")({
  component: LogoutPage,
})
